import React, { useEffect, useRef, useState } from "react";
import { Modal, Button, Form, Dropdown } from "react-bootstrap";
import commonApi from "../../CommonApi/CommonServices";
import { errorMessage, successMessage } from "../../Errors/Toast";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { NavLink } from "react-router-dom";
import { login, signUp } from "../../Redux/LoginAction";
import { get_user_info } from "../../Redux/userProfileAction";
import { resume_profile_data } from "../../Redux/ResumeAction";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import OnboardingModal from "./OnboardingModal";
import { showOnboardingAction } from "../../Redux/showOnboardingAction";
import { user_profile_info } from "../../Redux/ProfileAction";
import ReCAPTCHA from "react-google-recaptcha";
import SpinnerLoader from "../../webLoader/SpinnerLoader";

const SITE_KEY = "6Ldo1ZYrAAAAAESzeOsJMGAgKsO-6ihGJEQCeP7s"; // replace this

const LoginModal = (props) => {
  const [loginForm, setLoginForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const history = useNavigate();
  const location = useLocation();

  const Gender = [
    {
      title: "Female",
      id: "female",
    },
    {
      title: "Male",
      id: "male",
    },
  ];
  const [validated, setValidated] = useState(false);
  const [showLogin, setShowLogin] = useState("login");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [isValidInput, setIsValidInput] = useState(true);
  const [subId, setSubId] = useState(Gender[0].id);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [showError, setShowError] = useState(false);
  const [isCaptchaLoading, setIsCaptchaLoading] = useState(
    showLogin !== "login" ? true : false
  );

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setIsValidInput(true);
    } else if (name === "password") {
      setPasswordError("");
    }

    setLoginForm({ ...loginForm, [name]: value });
  };

  const handle = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    const email = loginForm.email.trim();
    const password = loginForm.password ? loginForm.password.trim() : "";

    let isFormValid = form.checkValidity(); // Bootstrap built-in validation
    let manualValid = true;

    // Email validation
    const isEmailValid = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
      email
    );
    setIsValidInput(isEmailValid);

    if (!email) {
      manualValid = false;
    } else if (!isEmailValid) {
      manualValid = false;
    }

    // Password validation
    if (!password && !showForgotPassword) {
      setPasswordError("Password is required.");
      manualValid = false;
    } else if (password && password.startsWith(" ") && !showForgotPassword) {
      setPasswordError("Please avoid space in start.");
      manualValid = false;
    } else if (!showForgotPassword) {
      setPasswordError("");
    }

    if (
      !isFormValid ||
      !manualValid ||
      (!passwordMatch && showLogin !== "login")
    ) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setValidated(false);
      if (!showForgotPassword && showLogin === "login") {
        Login();
      } else {
        if (showForgotPassword) {
          forgot_password();
        } else {
          if (!captchaValue) {
            setShowError(true);
          } else {
            signup();
            setShowError(false);
          }
        }
      }
    }
  };

  const signup = () => {
    // Create a new FormData object
    const formData = new FormData();

    // Append the fields from the data object to the FormData object
    formData.append("name", loginForm.name);
    formData.append("contact", loginForm.email);
    formData.append("password", loginForm.password);
    formData.append("confirm_password", loginForm.password);
    formData.append("gender", "male");
    formData.append("capture_value", captchaValue);

    // Make the API call using the FormData object
    commonApi
      .signup(formData)
      .then((res) => {
        if (res.status === 200 && res.success) {
          localStorage.setItem("token", res.token);
          localStorage.setItem("gender", "male");
          localStorage.setItem("verfied", false);
          localStorage.setItem("onboarding", false);

          dispatch(signUp("male", res.token, res.payment_status));
          props.onHide("showVerify", loginForm);
        } else {
          errorMessage(res.message);
        }
      })

      .catch((err) => {
        console.log("Err", err);
      });
  };
  const Login = () => {
    // Create a new FormData object
    const formData = new FormData();

    // Append the fields from the data object to the FormData object
    formData.append("contact", loginForm.email);
    formData.append("password", loginForm.password);

    // Make the API call using the FormData object
    commonApi
      .login(formData)
      .then((res) => {
        if (res.status === 200 && res.success) {
          // Handle success

          localStorage.setItem("token", res.token);
          localStorage.setItem("user_type", res.user_type);
          localStorage.setItem("gender", res.gender);
          localStorage.setItem("payment_status", res.payment_status);
          localStorage.setItem("onboarding", res.onboarding);
          localStorage.setItem("verfied", res.verfied);

          dispatch(
            login(
              res.gender,
              res.user_type,
              res.onboarding,
              res.payment_status,
              res.token,
              res.verfied
            )
          );

          if (res.verfied) {
            dispatch(user_profile_info("", res.token));
            dispatch(resume_profile_data("", res.token));
            history("/journey");
          } else {
            props.onHide("showLoginVerify", loginForm);
          }
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };
  const forgot_password = () => {
    // Create a new FormData object
    const formData = new FormData();
    formData.append("email", loginForm.email);

    // Make the API call using the FormData object
    commonApi
      .forgot_password(formData)
      .then((res) => {
        if (res.status === 200 && res.success) {
          successMessage(res.message);

          // setShowForgotPassword(false);
          setLoginForm({
            email: "",
          });
        } else {
          errorMessage(res.message);
        }
      })
      .catch((err) => {
        console.log("Err", err);
        return { type: "error", message: err.message };
      });
  };

  useEffect(() => {
    if (location.state && location.state?.type === "signup") {
      setShowLogin("signup");
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setLoginForm({
      name: "",
      email: "",
      password: "",
    });
    setValidated(false);
  }, [showLogin]);

  const CustomDropdownItem = ({ children, onClick }) => (
    <a
      onClick={onClick}
      className="dropdown-item"
      style={{ cursor: "pointer" }}
      role="button"
      tabIndex="0"
    >
      {children}
    </a>
  );

  const emailInputRef = useRef(null);
  const nameInputRef = useRef(null);
  const passInputRef = useRef(null);

  useEffect(() => {
    if (showLogin !== "login") {
      setCaptchaKey(Date.now()); // force re-render on modal open
    }
  }, [showLogin]);

  useEffect(() => {
    if (showLogin !== "login") {
      setIsCaptchaLoading(true); // force re-render on modal open
    }
  }, [showLogin]);

  return (
    <>
      <Modal
        id="join-modal"
        className="custom-modal1 custom-modal2 custom-modal3"
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <i
            className="fa-solid fa-xmark"
            onClick={() => {
              props.onHide();
            }}
          ></i>
        </Modal.Header>
        <Modal.Body>
          <div
            className={`gets-started-form-contain p-0 bg-transparent ${
              showForgotPassword && "forget-page"
            }`}
          >
            <div className="gets-started-holder gets-started-form-holder p-0">
              {isCaptchaLoading && showLogin !== "login" && (
                <div className="side-main-content">
                  <SpinnerLoader color="white" />
                </div>
              )}
              <div className="form-holder m-1">
                <Form noValidate validated={validated} onSubmit={handle}>
                  <h3 style={{ fontWeight: 600 }}>
                    {showForgotPassword && "Forget Password"}
                    {!showForgotPassword && showLogin === "login"
                      ? "Login"
                      : !showForgotPassword && "Tell us a little about you"}
                  </h3>
                  {showForgotPassword ? (
                    <div className="form-group get-started-form">
                      <Form.Label htmlFor="email" className="font-size">
                        Email
                      </Form.Label>
                      <Form.Control
                        ref={emailInputRef}
                        // id="email"
                        type="email"
                        name="email"
                        required
                        placeholder=""
                        autoComplete="off"
                        value={loginForm.email}
                        onChange={handleInputChange}
                        isInvalid={!isValidInput}
                        // onFocus={handleFocus}
                        // onBlur={handleBlur}
                        // style={{ width: '100%', padding: '10px', borderRadius: '5px' }}
                      />
                      <Form.Control.Feedback type="invalid">
                        {loginForm.email
                          ? "Email is invalid."
                          : "Email is required."}
                      </Form.Control.Feedback>
                    </div>
                  ) : (
                    <>
                      {showLogin !== "login" && (
                        <div className="form-group get-started-form">
                          <Form.Label htmlFor="name" className="font-size">
                            Name
                          </Form.Label>
                          <Form.Control
                            // id="name"
                            ref={nameInputRef}
                            name="name"
                            type="text"
                            pattern="^\S.*"
                            required={showLogin !== "login" ? true : false}
                            value={loginForm.name}
                            placeholder=""
                            autoComplete="off"
                            onChange={handleInputChange}
                          />

                          <Form.Control.Feedback type="invalid">
                            {loginForm.name
                              ? "Please avoid space in start."
                              : " Name is required."}
                          </Form.Control.Feedback>
                        </div>
                      )}

                      <div className="form-group get-started-form">
                        <Form.Label htmlFor="email" className="font-size">
                          Email
                        </Form.Label>
                        <Form.Control
                          // id="email"
                          ref={emailInputRef}
                          type="email"
                          name="email"
                          required
                          placeholder=""
                          autoComplete="off"
                          value={loginForm.email}
                          onChange={handleInputChange}
                          isInvalid={!isValidInput}
                        />
                        <Form.Control.Feedback type="invalid">
                          {loginForm.email
                            ? "Email is invalid."
                            : "Email is required."}
                        </Form.Control.Feedback>
                      </div>

                      <div className="form-group get-started-form">
                        <Form.Label htmlFor="password" className="font-size">
                          Password
                        </Form.Label>
                        <div style={{ position: "relative" }}>
                          <Form.Control
                            ref={passInputRef}
                            name="password"
                            type={showPassword ? "text" : "password"}
                            required
                            value={loginForm.password}
                            placeholder=""
                            autoComplete="off"
                            onChange={handleInputChange}
                            isInvalid={!!passwordError}
                          />
                          <span
                            onClick={togglePassword}
                            style={{
                              position: "absolute",
                              right: 10,
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "#666",
                            }}
                          >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                          </span>
                        </div>

                        {passwordError && (
                          <div className="invalid-feedback d-block">
                            {passwordError}
                          </div>
                        )}

                        {/* <Form.Control.Feedback type="invalid">
                          {loginForm.password
                            ? "Please avoid space in start."
                            : "Password is required."}
                        </Form.Control.Feedback> */}
                      </div>
                      {showLogin !== "login" && (
                        <>
                          <ReCAPTCHA
                            sitekey={SITE_KEY}
                            key={captchaKey}
                            asyncScriptOnLoad={() => {
                              setTimeout(() => {
                                setIsCaptchaLoading(false);
                              }, 3000);
                              // Hide loader once script loads
                            }}
                            onChange={(value) => {
                              console.log("Captcha value:", value);
                              setCaptchaValue(value);
                              setShowError(false);
                            }}
                            onErrored={() => {
                              setIsCaptchaLoading(false);
                              setCaptchaValue("");
                              setShowError(false);
                            }}
                            onExpired={() => {
                              setIsCaptchaLoading(false);
                              setCaptchaValue("");
                              setShowError(false);
                            }}
                          />
                          {showError && !captchaValue && (
                            <span className="invalid-feedback d-block m-0">
                              reCAPTCHA is required.
                            </span>
                          )}
                        </>
                      )}

                      {/* {showLogin !== "login" && (
                        <div className="form-group get-started-form">
                          <Form.Label htmlFor="name">
                            Confirm Password
                          </Form.Label>
                          <Form.Control
                            // id="name"
                            ref={conPasswordInputRef}
                            name="confirmPassword"
                            type="password"
                            required={showLogin !== "login" ? true : false}
                            value={loginForm.confirmPassword}
                            placeholder=""
                            autoComplete="off"
                            onChange={handleInputChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            Confirm password is required.
                          </Form.Control.Feedback>
                          {!passwordMatch && (
                            <div className="error_notice">
                              Passwords do not match!
                            </div>
                          )}
                        </div>
                      )} */}
                      {/* {showLogin !== "login" && (
                      <div className="custom-form-slect-field get-started-form">
                        <Form.Label htmlFor="gender">Gender</Form.Label>
                        <Dropdown style={{ width: "79%" }}>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            {subId &&
                              Gender.find((item) => item.id === subId)?.title}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {Gender.map((item, index) => (
                              <Dropdown.Item
                                as={CustomDropdownItem}
                                key={index}
                                onClick={() => handleSubDropdownChange(item.id)}
                              >
                                {item.title}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    )} */}
                    </>
                  )}
                  {showLogin === "login" ? (
                    <NavLink
                      className="account-anchor font-size"
                      onClick={() => {
                        if (showLogin === "login") {
                          setIsValidInput(true);
                          setValidated(false);
                          setShowForgotPassword(!showForgotPassword);
                          setLoginForm({
                            name: "",
                            email: "",
                            password: "",
                            // confirmPassword: "",
                            // gender: "",
                          });
                          setPasswordError("");
                          // setIsValidInput(true);
                          // setShowLogin("");
                        } else {
                          setIsValidInput(true);
                          setValidated(false);
                          setPasswordError("");

                          // setShowLogin("login");
                        }
                      }}
                    >
                      {showForgotPassword ? "Login?" : "Forget password?"}
                    </NavLink>
                  ) : (
                    ""
                  )}
                  <div>
                    <button
                      style={{ width: "30%" }}
                      type="submit"
                      className="custm-selct-icon-btn btn btn-primary btn-md mt-0 mr-5"
                    >
                      Next
                    </button>
                  </div>
                  {!showForgotPassword ? (
                    <NavLink
                      className="font-size account-anchor"
                      onClick={() => {
                        if (showLogin === "login") {
                          setIsValidInput(true);
                          setValidated(false);
                          setShowLogin("");
                          setPasswordError("");
                        } else {
                          setIsValidInput(true);
                          setValidated(false);
                          setShowLogin("login");
                          setPasswordError("");
                        }
                      }}
                    >
                      {showLogin === "login"
                        ? "I don’t have an account"
                        : "I have an account"}
                    </NavLink>
                  ) : (
                    ""
                  )}
                </Form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginModal;
